var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3C3.90694 3 3 3.90694 3 5V19C3 20.0931 3.90694 21 5 21H19C20.0931 21 21 20.0931 21 19V5C21 3.90694 20.0931 3 19 3H5ZM5 5H19V19H5V5ZM12 6C10.355 6 9 7.35499 9 9C9 10.645 10.355 12 12 12C13.645 12 15 10.645 15 9C15 7.35499 13.645 6 12 6ZM12 8C12.5641 8 13 8.43587 13 9C13 9.56413 12.5641 10 12 10C11.4359 10 11 9.56413 11 9C11 8.43587 11.4359 8 12 8ZM12 13C10.5236 13 9.16521 13.2326 8.08008 13.6992C7.53751 13.9325 7.05717 14.2248 6.67188 14.6309C6.28658 15.0369 6 15.6007 6 16.2168V18H18V17V16.2168C18 15.6007 17.7134 15.0369 17.3281 14.6309C16.9428 14.2248 16.4625 13.9325 15.9199 13.6992C14.8348 13.2326 13.4764 13 12 13ZM12 15C13.2546 15 14.3968 15.2223 15.1289 15.5371C15.4891 15.692 15.7376 15.8684 15.8652 16H8.13477C8.26236 15.8684 8.51087 15.692 8.87109 15.5371C9.60321 15.2223 10.7454 15 12 15Z",
    fill: "#546077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatarIcon.cb3d18194ae5002338a609fd379a2a86.svg";
export { ForwardRef as ReactComponent };